<template>
    <div class="pb-4">
        <v-row
            v-if="!value && !descriptionEdit"
            class="mx-0"
        >
            <v-col class="col-12 pa-0">
                <v-btn
                    depressed
                    class="grey-button no-bg font-italic"
                    :style="!isFullPage ? 'margin-left: -12px;' : 'margin-left: -10px'"
                    @click="focus_field('description')"
                >
                    <icon icon="FileText" />
                    <span class="subtitle-2 font-weight-regular px-1">
                        {{ $t("Add notes") }}
                    </span>
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            v-else
            class="mx-0"
        >
            <v-col
                class="col-sm-6 col-6 pa-0"
                style="line-height: 28px;"
            >
                <div class="global-label">
                    {{ $t("Description") }}
                </div>
            </v-col>
        </v-row>
        <v-row class="mx-0">
            <v-col class="px-0 py-0">
                <div
                    v-if="!descriptionEdit"
                    class="pt-1"
                    style="letter-spacing: normal; font-weight: 400; font-size: 14px; line-height: 1.25rem; cursor: pointer;"
                    @click="onDescriptionClick($event)"
                    v-html="$options.filters.nl2br(value)"
                ></div> <!-- INPUT CLEANED WHEN SAVING -->
                <div v-else>
                    <v-textarea
                        ref="descriptionField"
                        :value="value && getDescriptionWithoutLinks(value)"
                        class="pt-0 body-2"
                        rows="1"
                        auto-grow
                        dense
                        hide-details
                        @blur="save_description($event)"
                    ></v-textarea>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Vue from "vue";
import { getDescriptionWithLinks, getDescriptionWithoutLinks } from "@/helpers/formatting";

export default {
    name: "TaskNotesComponents",
    props: {
        descriptionEdit: {
            type: Boolean,
            default: false
        },
        isFullPage: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        }
    },
    setup(props, ctx) {
        const focus_field = function(field_name) {
            ctx.emit('focus_field', field_name)
        };

        const onDescriptionClick = e => {
            if (e.target.tagName.toLowerCase() === "a") {
                e.preventDefault();
                e.stopPropagation();
                window.open(e.target.href);
            } else {
                Vue.nextTick(function() {
                    focus_field("description");
                });
            }
        };

        const save_description = function(e) {
            let description = getDescriptionWithLinks(e.target.value);
            if (description !== props.value) {
                ctx.emit('input', description)
                ctx.emit('save_field', description)
            } else {
                ctx.emit('descriptionEdit', false);
            }
        };

        return {
            focus_field,
            onDescriptionClick,
            save_description,
            getDescriptionWithoutLinks
        };
    }
};
</script>

<style scoped lang="scss">
.v-textarea ::v-deep textarea {
    line-height: 1.25rem !important;
}
</style>